import { InputLabel, SxProps, TextField, Theme } from '@mui/material';

import { FieldWrapperPassThroughProps } from './FieldWrapper';

type DatePickerFieldProps = FieldWrapperPassThroughProps & {
  disabled?: boolean;
  value?: string;
  min?: string;
  max?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  sx?: SxProps<Theme>;
};

export function DatePickerField(props: DatePickerFieldProps) {
  const { id, label, isRequired, error, sx, value = '', min = '', max = '', disabled = false, onChange } = props;

  return (
    <>
      <InputLabel htmlFor={id}>
        {label}
        {isRequired ? '*' : ''}
      </InputLabel>
      <TextField
        id={id}
        value={value}
        type='date'
        InputLabelProps={{ shrink: true }}
        InputProps={{
          inputProps: {
            min,
            max,
            'data-testid': `${id}`,
          },
          disabled,
        }}
        error={!!error}
        helperText={error?.message}
        variant='outlined'
        size='small'
        fullWidth
        onChange={onChange}
        sx={sx}
      />
    </>
  );
}
